import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {Link, useHistory} from 'react-router-dom';
import moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Resizer from "react-image-file-resizer";
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";

function Adoption() {

  const history = useHistory()
  const urlLocation = window.location.href;

    const hiddenFileInput = React.useRef(null);
    const [btnMessage, setBtnMessage] = useState("Publicar mascota");
    const [btnMessageUpdate, setBtnMessageUpdate] = useState("Actualizar mascota");
    const [pets, setPets] = useState([])
    const [productsTypes, setProductsTypes] = useState([])
    const [update, setUpdate] = useState(false);
    const [adoptado, setAdopatado] = useState(false);
    const [apadrinado, setApadrinado] = useState(false);
    const [species, setSpecies] = useState([])
    const [sexos, setSexos] = useState([])
    const [paises, setPaises] = useState([])
    const [user, setUser] = useState({})
    const [pet, setPet] = useState({})
    const url2 = window.location.href;
    const [error, setError] = useState(false) 
    const [emessage, setEmessage] = useState("")
    const [success, setSuccess] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const [nombre, setNombre] = useState("");
    const [secondFilterStatus, setSecondFilterStatus] = useState("");

    const [interesadosStatus, setInteresadosStatus] = useState(false);
    const [interesteds, setInteresteds] = useState([]);

    const [petInfo, setPetInfo] = useState({
      nombreMascota: "",
      historiaMascota: "",
      sexoMascota: "",
      especieMascota: "",
      edadTamanoMascota: "",
      tamanoMascota: "",
      adoptadoPor: "",
      pais: "",
      apadrinadoPor: "",
      costoApadrinar: 0,
      costoCachorro: 0,
      costoAdulto: 0,
    })
    const [petUInfo, setPetUInfo] = useState({
      nombreMascota: null,
      historiaMascota: null,
      especieMascota: null,
      edadTamanoMascota: null,
      tamanoMascota: null,
      adoptadoPor: null,
      apadrinadoPor: null,
      costoApadrinar: null,
      costoCachorro: null,
      costoAdulto: null,
    })

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
    const etapaLista = ["Cachorro", "Adulto"];
    const tamañoLista = ["Pequeño", "Mediano", "Grande"];
    const [disponibleApadrinar, setDisponibleApadrinar] = useState(false)
    const [disponibleAdoptar, setDisponibleAdoptar] = useState(false)
    
    const [showOwnerInfo, setShowOwnerInfo] = useState(false)
    
    const [ownerInfo, setOwnerInfo] = useState({})
    const [confirmationText, setConfirmationText] = useState('');

    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    async function handleChange(e) {
      var file = e.target.files[0]
      Compress.imageFileResizer(
        file,
        600,
        300,
        "JPEG",
        10,
        0,
        (uri) => {
          setFile(uri)
          console.log(uri)
        },
        "file",
        600,
        300
      )
      setImg(URL.createObjectURL(file))
    }

    const getPets = async(aliadoId) =>{

      setInteresadosStatus(false)

      let tipos = [];
      let reference = firebase.db.collection('Mascotas').where("aliadoId", "==", aliadoId)
      let referenceNombre = nombre !== "" ? reference.where("nombre", "==", nombre) : reference
      let query

      if(secondFilterStatus === "Adoptado") query = referenceNombre.where("adoptadoStatus", "==", true)
      if(secondFilterStatus === "Apadrinado") query = referenceNombre.where("apadrinadoStatus", "==", true)
      if(secondFilterStatus === "Por apadrinar") query = referenceNombre.where("apadrinadoStatus", "==", false)
      if(secondFilterStatus === "Por adoptar") query = referenceNombre.where("adoptadoStatus", "==", false)

      await (query ?? referenceNombre).get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
          tipos.sort()
        })
        setPets(tipos)
      })
    }
    
    const getPetsSpecies = async() =>{
      let tipos = [];
      await firebase.db.collection('Especies')
      .get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.id)
          tipos.sort()
        })
        setSpecies(tipos)
      })
    }
    
    const getPaises = async() =>{
      let tipos = [];
      await firebase.db.collection('Ciudades')
      .get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.id)
          tipos.sort()
        })
        setPaises(tipos)
      })
    }
    
    const getPetsGender = async() =>{
      let tipos = [];
      await firebase.db.collection('SexoMascota')
      .get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.id)
        })
        setSexos(tipos)
      })
    }

    function checkInputs(){
      let val = 0
      let array = []
      let object = {
        nombre: petInfo.nombreMascota,
        historia: petInfo.historiaMascota,
        sexo: petInfo.sexoMascota,
        especie: petInfo.especieMascota,
        edadMascota: petInfo.edadTamanoMascota,
        tamanoMascota: petInfo.tamanoMascota,
        costroApadrinar: user.pais === "Perú" ? 0 : parseFloat(petInfo.costoApadrinar),
        costoCachorro: parseFloat(petInfo.costoCachorro),
        costoAdulto: parseFloat(petInfo.costoAdulto),
        pais: petInfo.pais,
      }
      Object.keys(object).forEach(function(key) {
        if (object[key] === '' || object[key] === null) {
          val++
          array.push(key)
        }
      });
      if(val > 0){
        setError(true)
        setEmessage("Todos los campos son requeridos")
        setTimeout(() => {
          setError(false)
        }, 4000);
        setBtnMessage("Publicar mascota")
      }else{
        uploadPet()
      }
      return val > 0 ? true : false
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    async function approveUser(user){

      //  var config = {
      //   headers: {
      //     'Content-type': 'application/json; charset=utf-8',
      //     'Access-Control-Allow-Origin':'*',
      //     'Access-Control-Allow-Methods': 'POST',
      //     'Access-Control-Allow-Headers':'Content-Type',
      //     // 'Access-Control-Allow-Credentials': true,
      //     'cache-control': 'no-cache'
      //   }
      // };
  
      // var token = user.token;
      // var token = "dUt0y7H0TpGBnk3hffW5G8:APA91bELRiesj-KpdpSF8ZkH5zj27wU-fe6jkJmlDDq0FxtIr21qzW3yxRBWkHBP9ZF8U-H9Kp7RpSLQyhNWiWPC1U-K4YtVb4XuqUIxCSAdurAQpG3jh94waorae0V-zf9qNkMcvAa2";
  
      // const notificationData = { registrationToken: token, message: "Prueba de envio desde la web" };
      // axios.post('https://us-central1-priority-pet.cloudfunctions.net/widgets/sendNotification', notificationData, config)
      // .then(response => alert(response));
  
      try{
        await firebase.db.collection("Mascotas").doc(user.mid).update({
          newPet: true,
          newOwner: user.uid
        }).then((v)=>{
          setSuccessMsg("Al nuevo dueño se le notificará que fue aprobado")
          setSuccess(true)
          setTimeout(() => {
            setSuccess(false)
          }, 4000);
        })
        
  
      }catch(e){
        console.log("Error: " + e)
      }
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getPets(val.aliadoId)
          setPetInfo({...petInfo, pais: val.pais})
          utils.getPetInterested(val.aliadoId).then((v)=>{
            setInteresteds(v)
            console.log(v)
          })
        });
        getPetsGender()
        getPaises()
        getPetsSpecies()
    }, [])

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className="main-content-container container-fluid px-4">
          {error && <ErrorComponent msg={emessage === "" ? "Todos los campos son requeridos" : emessage}/>}
          {success && <SuccessComponent msg={successMsg === "" ? "Mascota cargada exitosamente" : successMsg}/>}
          { deleteModal && <div className="cc-modal-wrapper fadeIn">
              <div className="c2-modal">
                  <div className="cc-modal-header">
                      <span className="mb-0 material-icons" style={{color: "var(--danger)", fontSize: "69px"}}>cancel</span>
                  </div>
                  <div className="c2-modal-body">
                     <p className="mb-0">
                         ¿Desea eliminar a esta mascota?
                     </p>
                  </div>
                  <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                    <button onClick={()=>{setDeleteModal(false)}} className="mr-2 btn btn-outline-secondary">
                      No
                    </button>
                    <button onClick={()=>{ deletePet() }} className="ml-2 btn btn-danger">Eliminar</button>
                  </div>
              </div>
          </div>}
          
          <div className={`right-side-info ${ownerInfo.email !== undefined && "active" }`}>
            <div className="right-side-info-header">
              
              <div className="right-side-info-title">
                Interesado
              </div>
              <div onClick={()=>{ setOwnerInfo({}) }}  className="right-side-info-back">
                <i className="material-icons">arrow_back</i> Cerrar
              </div>

            </div>
            <div className="right-side-info-body">
              
              <div className="interested-card-header mb-3">
                <div className="interested-card-header-img">
                  <img src={ownerInfo.url}/>
                </div>
              </div>
              <div className="interested-card-body">
                <div className="interested-card-body-p-wrapper mb-2">
                  <p className="interested-card-body-p-title color-secondary mb-0">Nombre completo</p>
                  <p className="color-primary mb-0">{ownerInfo.nombre} {ownerInfo.apellido}</p>
                </div>
                <div className="interested-card-body-p-wrapper mb-2">
                  <p className="interested-card-body-p-title color-secondary mb-0">email</p>
                  <p className="color-primary mb-0">{ownerInfo.email}</p>
                </div>
                <div className="interested-card-body-p-wrapper mb-2">
                  <p className="interested-card-body-p-title color-secondary mb-0">Teléfono</p>
                  <p className="color-primary mb-0">{ownerInfo.telefono}</p>
                </div>
                <div className="interested-card-body-p-wrapper">
                  <p className="interested-card-body-p-title color-secondary mb-0">Interesado en</p>
                  <p className="color-primary mb-0">{ownerInfo.namePet}</p>
                </div>
              </div>
              <div className="px-3 mt-3">
                
                { ownerInfo.petUid === null && (ownerInfo.newOwner === ownerInfo.uid) 
                  ?
                    <div className="interested-card-text-success">
                      Pendiente por confirmación
                    </div>
                  : ownerInfo.petUid !== null && (ownerInfo.newOwner === ownerInfo.uid) ? 
                    <div className="interested-card-text-success">
                      Ha adoptado a {ownerInfo.namePet}
                    </div>
                  : ownerInfo.newOwner !== null && ownerInfo.newOwner !== ownerInfo.uid ? 
                    <div className="interested-card-text-danger">
                      Adoptado por otro cliente
                    </div>
                  : <>
                    <button onClick={()=>{ 
                      history.push({
                        pathname: "/clients/client", 
                        state: { uid: ownerInfo.uid }
                      })
                    }} className="btn-block btn btn-outline-primary mb-3">
                      Información completa
                    </button>
                    <button onClick={()=>{ approveUser(ownerInfo) }} className="btn-block btn btn-outline-success mb-3">
                      Aprobar<i className="material-icons">done</i>
                    </button>
                    <button onClick={()=>{ }} className="btn-block btn btn-outline-danger">
                      Rechazar<i className="material-icons">close</i>
                    </button>
                  </>
                }

              </div>

            </div>

          </div>

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="col">
                    <p className="page-title"><span>Adoptar o Apadrinar</span></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around">
                  <i className="material-icons color-white display-5">help_outline</i>
                </div>
              </div>
            </div>
            <div className="form-row align-items-center justify-content-spacebetween mb-4">

              <div className="row no-gutters align-items-center">
                <div className="form-group mb-0">
                  {/* <input type="checkbox" onClick={()=>{setAdopatado(!adoptado)}} name="ad"/>
                  <label className="mb-0 ml-2" htmlFor="ad">Por adoptar/apadrinar</label> */}
                  <input className="form-control" placeholder="Nombre de la mascota" value={nombre} onChange={(e)=>{ setNombre(e.target.value) }}/>
                </div>
                <div className="form-group ml-3 mb-0">

                  <select className="form-control" placeholder="" value={secondFilterStatus} onChange={(e)=>{ setSecondFilterStatus(e.target.value) }}>
                    <option value="">Selección</option>
                    <option value="Por adoptar">Por adoptar</option>
                    <option value="Por apadrinar">Por apadrinar</option>
                    <option value="Adoptado">Adoptado</option>
                    <option value="Apadrinado">Apadrinado</option>
                  </select>
                </div>
                {/* <div className="form-group ml-3">
                  <input type="checkbox" onClick={()=>{setApadrinado(!apadrinado)}} name="ap"/>
                  <label className="mb-0 ml-2" htmlFor="ap">Adoptado/apadrinado</label>
                </div> */}
                <div className="ml-3 form-group mb-0">
                  <button className="btn btn-primary" onClick={()=>{getPets(user.aliadoId)}}><i className="material-icons">search</i></button>
                </div>
                <div className="ml-3">
                  <button className={`btn ${interesadosStatus ? "btn-secondary" : "btn-outline-secondary"}`} onClick={()=>{ setInteresadosStatus(!interesadosStatus); setOwnerInfo({}) }}>Solicitudes</button>
                </div>

              </div>

              <div className="mt-1 mb-0 row no-gutters" style={{width: "420px"}}>
                <a href="../docs/excel-carga-mascotas.xlsx" download className="special-button">
                  <img src="../images/icons/excel.png" alt="" />
                  <p className="mb-0">Formato de excel</p>
                </a>
                <Link to="/adoption/upload-excel" className="special-button cursor-pointer">
                  <img src="../images/icons/upload.png" alt="" />
                  <p className="mb-0">Cargar archivo de excel</p>
                </Link>
              </div>

            </div>
            <div className="row">
              { interesadosStatus ?
                <div className="col-lg-12">
                  
                  <div className="mb-2 row orders-title">

                    <div className="col-md-1"></div>
                    <div className="col-md-4">
                      <p className="mb-2">Nombre de la mascota</p>
                    </div>
                    <div className="col-md-4">
                      <p className="mb-2">Nombre del interesado</p>
                    </div>
                    <div className="col-md-2">
                      <p className="mb-2">Solicitud</p>
                    </div>

                  </div>

                  <div className="orders-container">
                    { interesteds.length > 0 ? interesteds.map((owner, i) => {
                      return (

                        <div onClick={() => { setOwnerInfo(owner); }} style={{padding: "10px 0px"}} className="mb-2 row order-child align-items-center">

                          <div className="col-lg-1">
                            <img className="client-avatar-preview rounded-circle cursor-pointer" src={owner.petthumbnailUrl} alt="User Avatar"/>
                          </div>

                          <div className="col-md-4">
                            <p className="mb-0">{owner.namePet}</p>
                          </div>
                          <div className="col-md-4">
                            <p className="mb-0">{owner.nombre} {owner.apellido}</p>
                          </div>
                          <div className="col-md-2">
                            <p className="mb-0">Adopción</p>
                          </div>

                        </div>

                      )
                    }) : <p className="text-center">No hay interesado aún</p> }
                  </div>
                </div>
              : <>      
              {/* Pet card */}
              <div className="col-lg-7 col-md-7 col-sm-12">
                  <div className="row justify-content-space-between">
                    {
                      pets.length > 0 ? pets.map((pet, i)=>{
                          return(
                            <div className="col-md-4 col-sm-12">
                              <div onClick={() =>{ setPet(pet); setUpdate(false); setSelectedIndex(i)}} key={pet.mid} className="pet-img mb-4">
                                <img src={pet.petthumbnailUrl} alt={pet.petthumbnailUrl}/>
                              </div>
                          </div>
                      )
                    }) : <div className="text-center"><p>No hay mascotas</p></div>
                  }
                  </div>
              </div>
              {/* End Pet card */}
              {/* Upload Pet card */}
                <div className="col-lg-5 col-md-5 col-sm-12">
                    { pet.nombre != null  && !update ? 
                    // Info pet card
                    <div className="card">
                      <div className="card-header-img">
                        <img src={pet.petthumbnailUrl} alt=""/>
                      </div>                      
                      <div className="card-footer">
                        <button onClick={()=>{
                            history.push({
                              pathname: "/proceedings", 
                              state: {mid: pet.mid}
                            })
                        }} className="btn btn-outline-secondary btn-block mb-2">Expediente médico</button>
                        {/* <button onClick={()=>{
                            history.push({
                              pathname: "/adoption/interested", 
                              state: {pet: pet}
                            })
                        }} className="btn btn-outline-success btn-block">Ver interesados</button>      */}
                      </div>                   
                      <div onClick={()=>{setPet({})}} className="card-close-btn">
                        <span>X</span>
                      </div>
                      <div className="px-4">
                        
                        <div className="card-claim-box">
                          <p className="card-claim-text">{pet.nombre}</p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Historia</p>
                          <p className="card-claim-text">{pet.historia}</p>
                        </div>
                        <p style={{width: "fit-content"}} className="pill-2 rounded my-2">{pet.adoptadoStatus ? "Adoptado" : "Por adoptar" }</p>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Especie: {pet.especie}</p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Edad: {pet.edadMascota} </p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Tamaño de la mascota: {pet.tamanoMascota}</p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Adoptado por: {pet.adoptadoPor}</p>
                        </div>
                        <div className="card-claim-box">
                          <p className="card-claim-title">Apadrinado por: {pet.apadrinadoPor}</p>
                        </div>

                      </div>
                      <div className="card-footer">
                        { (pet.adoptadoStatus && (urlLocation.includes("prioritypet-aliados") || urlLocation.includes("localhost") ) ) && <button onClick={()=>{ redoPet() }} className="btn btn-block btn-outline-secondary mb-2">
                          Devolución <span style={{position: "relative",bottom: "-5px",left: "4px",lineHeight: "0px"}} class="icon-reduced material-icons">autorenew</span>
                        </button> }
                        <div className="row no-gutters align-items-center justify-content-spacebetween">
                            <button onClick={()=>{setDeleteModal(true)} } className="col-md-3 py-2 btn btn-outline-danger"><span class="icon-reduced material-icons">delete</span></button>
                            <button onClick={()=>{setUpdate(true); }} className="col-md-8 btn btn-primary">Editar mascota</button>
                        </div>
                      </div>
                    </div>
                    // End info pet card
                    : update ?
                    // Update info pet card
                    <form onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Actualizar mascota</h4>
                        </div>
                        <div onClick={()=>{setPet({}); setUpdate(false)}} className="card-close-btn">
                          <span>X</span>
                        </div>
                        <div className="px-4">

                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img">
                            {src !== "" ? <img src={src} alt="" /> : <img src={pet.petthumbnailUrl} alt="" />}
                          </div>

                          <div className="form-group">
                            <p className="mb-1">Nombre de la mascota</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, nombreMascota: e.target.value})}} placeholder={pet.nombre} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <p className="mb-1">Historia de la mascota</p>
                            <textarea type="text" onChange={(e)=>{setPetUInfo({...petUInfo, historiaMascota: e.target.value})}} placeholder={pet.historia} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <p className="mb-1">Especie de la mascota</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, especieMascota: e.target.value})}} placeholder={pet.especie} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <p className="mb-1">Edad de la mascota</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, edadTamanoMascota: e.target.value})}} placeholder={pet.edadMascota} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <p className="mb-1">Tamaño de la mascota</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, tamanoMascota: e.target.value})}} placeholder={pet.tamanoMascota} className="form-control"/>
                          </div>
                          
                          {user.pais !== "Venezuela" && 
                            <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                              <div className="col-lg-4 text-left">Disponible para padrinaje</div>
                              <div className="col-lg-3 text-center">
                                <input type="checkbox" defaultChecked={pet.costroApadrinar === 0 || pet.costroApadrinar === null ? false : true} value={disponibleApadrinar} onClick={()=>{setDisponibleApadrinar(disponibleApadrinar ? false : true)}} name="ab"/>
                              </div>
                              <div className="col-lg-5 text-right">
                                <div className="form-group mb-0">
                                  <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, costoApadrinar: e.target.value})}} defaultValue={pet.costroApadrinar} className="form-control col-lg-12"/>
                                </div>
                              </div>
                            </div>
                          }
                          
                          <div className="form-group">
                            <p className="mb-1">Costo por cachorro</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, costoCachorro: e.target.value})}} defaultValue={pet.costoCachorro} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <p className="mb-1">Costo por adulto</p>
                            <input type="text" onChange={(e)=>{setPetUInfo({...petUInfo, costoAdulto: e.target.value})}} defaultValue={pet.costoAdulto} className="form-control"/>
                          </div>

                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{updatePet()}} className="btn btn-primary btn-block">{btnMessageUpdate}</button>
                        </div>
                      </div>
                    </form>
                    // End update info pet card
                    :
                    // Upload pet card
                    <form onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Publicar mascota</h4>
                        </div>
                        <div className="px-4">

                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img">
                            {src !== "" ? <img src={src} alt="" /> : <div className="card-header-img-upload"><p className="material-icons icon">add</p><p>Foto de la mascota</p></div>}
                          </div>

                          <div className="form-group">
                            <input type="text" onChange={(e)=>{setPetInfo({...petInfo, nombreMascota: e.target.value})}} placeholder="Nombre de la mascota" className="form-control"/>
                          </div>
                          <div className="form-group">
                            <textarea type="text" onChange={(e)=>{setPetInfo({...petInfo, historiaMascota: e.target.value})}} placeholder="Historia de la mascota" className="form-control"/>
                          </div>
                          <div className="form-group">
                            <select className="form-control" value={petInfo.pais} onChange={(e)=>{setPetInfo({...petInfo, pais: e.target.value})}}>
                              <option value="">País de la mascota</option>
                              {paises.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <select className="form-control" value={petInfo.sexoMascota} onChange={(e)=>{setPetInfo({...petInfo, sexoMascota: e.target.value})}}>
                            <option value="">Sexo de la mascota</option>
                              {sexos.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <select className="form-control" value={petInfo.especieMascota} onChange={(e)=>{setPetInfo({...petInfo, especieMascota: e.target.value})}}>
                              <option value="">Especie de la mascota</option>
                              {species.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <select className="form-control" value={petInfo.edadTamanoMascota} onChange={(e)=>{setPetInfo({...petInfo, edadTamanoMascota: e.target.value})}}>
                              <option value="">Etapa de la mascota</option>
                              {etapaLista.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <select className="form-control" value={petInfo.tamanoMascota} onChange={(e)=>{setPetInfo({...petInfo, tamanoMascota: e.target.value})}}>
                              <option value="">Tamaño de la mascota</option>
                              {tamañoLista.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          { user.pais !== "Venezuela" && 
                            <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                              <div className="col-lg-4 text-left">Disponible para padrinaje</div>
                              <div className="col-lg-3 text-center">
                                <input type="checkbox" onClick={()=>{setDisponibleApadrinar(!disponibleApadrinar)}} name="ad"/>
                              </div>
                              <div className="col-lg-5 text-right">
                                <div className="form-group mb-0">
                                  {disponibleApadrinar
                                    ?
                                    <input type="text" onChange={(e)=>{setPetInfo({...petInfo, costoApadrinar: e.target.value})}} placeholder="Costo mensual" className="form-control"/>
                                    :
                                    <input type="text" disabled={true} onChange={(e)=>{setPetInfo({...petInfo, costoApadrinar: e.target.value})}} placeholder="Costo mensual" className="form-control"/>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                            <div className="col-lg-6 text-left">Disponible para adoptar</div>
                            <div className="col-lg-6 text-right">
                              <input type="checkbox" onClick={()=>{setDisponibleAdoptar(!disponibleAdoptar)}} name="ab"/>
                            </div>
                          </div>
                          <div className="form-group">
                            <input type="text" disabled={disponibleAdoptar ? false : true} onChange={(e)=>{setPetInfo({...petInfo, costoCachorro: e.target.value})}} placeholder="Contribución única por cachorro" className="form-control"/>
                          </div>
                          <div className="form-group">
                            <input type="text" disabled={disponibleAdoptar ? false : true} onChange={(e)=>{setPetInfo({...petInfo, costoAdulto: e.target.value})}} placeholder="Contribución única por adulto" className="form-control"/>
                          </div>
                        
                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{ checkInputs(petInfo) }} className="btn btn-primary btn-block">{btnMessage}</button>
                        </div>
                      </div>
                    </form>
                    // End upload pet card
                  }
                </div>
              </> }
            </div>
          </div>
        </MuiPickersUtilsProvider>
    )

    async function uploadPet() {
      setBtnMessage("Subiendo...")
      let id = Date.now().toString()
      try {
        await firebase.storage.ref(`/Mascotas imagenes/${file.name}`).put(file)
        await firebase.storage.ref("Mascotas imagenes").child(file.name).getDownloadURL().then((url) => {
          firebase.db.collection("Mascotas").doc(id).set({
            aliadoId: user.aliadoId,
            mid: id,
            petthumbnailUrl: url,
            nombre: petInfo.nombreMascota,
            historia: petInfo.historiaMascota,
            sexo: petInfo.sexoMascota,
            especie: petInfo.especieMascota,
            edadMascota: petInfo.edadTamanoMascota,
            tamanoMascota: petInfo.tamanoMascota,
            costroApadrinar: !disponibleApadrinar ? null : parseFloat(petInfo.costoApadrinar),
            costoCachorro: !disponibleAdoptar ? null : parseFloat(petInfo.costoCachorro),
            costoAdulto: !disponibleAdoptar ? null : parseFloat(petInfo.costoAdulto),
            pais: petInfo.pais,
            adoptadoStatus: false,
            apadrinadoStatus: false,
            createdOn: moment().toDate(),
          }).then((val)=>{
            window.location.href = "/adoption"
          })
        })
      } catch(error) {
        alert(error.message)
      }
    }
      
    async function updatePet(){
      setBtnMessageUpdate("Actualizando...")
      if(file){
        await firebase.storage.ref(`/Mascotas imagenes/${file.name}`).put(file)
        firebase.storage.ref("Mascotas imagenes").child(file.name).getDownloadURL().then((url) => {
          firebase.db.collection("Mascotas").doc(pet.mid).update({
            petthumbnailUrl: url,
            nombre: petUInfo.nombreMascota ?? pet.nombre,
            historia: petUInfo.historiaMascota ?? pet.historia,
            especie: petUInfo.especieMascota ?? pet.especie,
            edadMascota: petUInfo.edadTamanoMascota ?? pet.edadMascota,
            tamanoMascota: petUInfo.tamanoMascota ?? pet.tamanoMascota,
            costroApadrinar: !disponibleApadrinar ? null : ( petUInfo.costoApadrinar ? parseFloat(petUInfo.costoApadrinar) : pet.costroApadrinar ),
            costoAdulto: petUInfo.costoAdulto ? parseFloat(petUInfo.costoAdulto) : pet.costoAdulto,
            costoCachorro: petUInfo.costoCachorro ? parseFloat(petUInfo.costoCachorro) : pet.costoCachorro
          }).then((val)=>{
            window.location.href = "/adoption"
          })
        })
      }else{
        try {
          await firebase.db.collection("Mascotas").doc(pet.mid).update({
            nombre: petUInfo.nombreMascota ?? pet.nombre,
            historia: petUInfo.historiaMascota ?? pet.historia,
            especie: petUInfo.especieMascota ?? pet.especie,
            edadMascota: petUInfo.edadTamanoMascota ?? pet.edadMascota,
            tamanoMascota: petUInfo.tamanoMascota ?? pet.tamanoMascota,
            costroApadrinar: !disponibleApadrinar ? null : ( petUInfo.costoApadrinar ? parseFloat(petUInfo.costoApadrinar) : pet.costroApadrinar ),
            costoAdulto: petUInfo.costoAdulto ? parseFloat(petUInfo.costoAdulto) : pet.costoAdulto,
            costoCachorro: petUInfo.costoCachorro ? parseFloat(petUInfo.costoCachorro) : pet.costoCachorro
          })
          window.location.href = "/adoption"

        } catch (e) {
          alert(e.message)
        }

      }

      setBtnMessageUpdate("Actualizar mascota")

    }
  
    async function deletePet(){
      try{
        await firebase.db.collection('Mascotas').doc(pet.mid).delete().then((val)=>{
          setDeleteModal(false)
          setSuccessMsg("Mascota eliminada exitosamente")
          setSuccess(true)
          getPets(user.aliadoId)
          setPet({})
          setTimeout(() => {
            setSuccess(false)
          }, 4000);
        })
      }catch(e){
        console.log("Error: " + e);
      }
    }
    
    async function redoPet(){
      try{
        await firebase.db.collection('Mascotas').doc(pet.mid).update({
          uid: null,
          newOwner: null,
          adoptadoStatus: false
        })

        let i = selectedIndex
        let lista = [...pets]
        lista[i].adoptadoStatus = false
        setPets(lista)

        setSuccessMsg("Mascota regresada exitosamente")
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
          // window.location.href = "/adoption"
        }, 4000);

      }catch(e){
        console.log("Error: " + e);
      }
    }

}

export default Adoption